import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';
import { LoadingOverlay } from '@mantine/core';
import { observer } from 'mobx-react-lite';

import { UnauthorizedFail } from '../../core/data/unauthorized-fail';
import { apiClient } from '../../core/libs/api';
import { HttpResource } from '../../core/libs/http-resource';
import { AppNotify } from '../../features/app-notify/app-notify';
import { authStore } from '../auth/auth.store';
import { ProfileStore } from './profile.store';
import { getUserDetails } from './requests/get-user-info.request';

export const ProfileContext = createContext(new ProfileStore());

export const useProfileStore = () => {
  return useContext(ProfileContext);
};

export const ProfileProvider = observer(({ children }: PropsWithChildren) => {
  const [profileStore] = useState(() => new ProfileStore());
  const [notify] = useState(() => new AppNotify());

  const [userRequest] = useState(
    () =>
      new HttpResource<void, any>({
        apiClient,
        httpRequest: getUserDetails,
        onFinish(data) {
          if (data?.user?.login) {
            authStore.accessGranted();
            profileStore.setUserData(data);
          }
        },
        onError: (error) => {
          // if (error.message === t`Пользователь не авторизован`) return;
          if (error instanceof UnauthorizedFail) return;

          notify.addMessage({ message: error.message, type: 'error' });
        },
      })
  );

  useEffect(() => userRequest.send(), [userRequest]);

  if (userRequest.isWaitingForLoad)
    return <LoadingOverlay visible={userRequest.isWaitingForLoad} />;

  return (
    <ProfileContext.Provider value={profileStore}>
      {children}
    </ProfileContext.Provider>
  );
});
